module.exports = __webpack_public_path__ + "static/media/group-search.f84c3c11.svg";